import { render, staticRenderFns } from "./Footercalendar.vue?vue&type=template&id=ce6b67b8&scoped=true&"
import script from "./Footercalendar.vue?vue&type=script&lang=js&"
export * from "./Footercalendar.vue?vue&type=script&lang=js&"
import style0 from "./Footercalendar.vue?vue&type=style&index=0&id=ce6b67b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6b67b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
